export default "__VITE_ASSET__CvHbCN7m__"